{
    "SignInWith_Title": "Iniciar sessão com",
    "NAME": "SignInWith",
    "SignInWith_OtherOptions": "Outras opções"
}